import http from './http';
import notifier from '../_utils/notifier';

const couponsAPI = {
  getList(){
    return http.get('coupons/')
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке страницы произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  getAvailableList(id=null, offerType=null){
    let params = {};
    if (id) params.object_id = id;
    if (offerType) params.offer_type = offerType;
    return http.get('coupons/available/', { params })
    .then(
      function(success) { return success },
      function(error) {
        notifier.alert(gettext('При загрузке купонов произошла ошибка. ') + '<br>' + error.messages);
      }
    )
  },

  validate(code, offerType=null){
    let params = {};
    if (offerType) params.offer_type = offerType;
    return http.get(`coupons/${code}/`, { params })
    .then(
      function(success) { return success },
      function(error) {
        throw new Error(error.messages);
      }
    )
  }
};


export default couponsAPI;

